import moment from 'moment';
import { isMobile } from 'react-device-detect';
import { LabelInput } from '../../../components/Input/Input';

const getStatusInfo = (statusId) => {
  const statusMap = {
    1: { label: 'Aberta', color: '#4682B4' },
    2: { label: 'Fechada', color: '#b36a22' },
    3: { label: 'Quitada', color: '#00A86B' },
  };
  return statusMap[statusId] || { label: 'Desconhecido', color: '#b5b5b5' };
};

const TabDetails = ({
  values,
  selectedClient,
  selectedVehicle,
  selectedFinancialCoresponsible,
  consultant,
}) => {
  const statusInfo = getStatusInfo(values?.status);

  return (
    <div>
      {/* Cliente */}
      <div style={{ marginTop: '10px' }}>
        <LabelInput
          onChange={() => {}}
          placeholder={'Escolha o Cliente'}
          disabled={true}
          label={'Cliente'}
          value={selectedClient ? selectedClient.label : null}
        />
      </div>

      {/* Veículo */}
      <div style={{ marginTop: '10px' }}>
        <LabelInput
          onChange={() => {}}
          placeholder={'Escolha o Veículo'}
          label={'Veículo'}
          disabled={true}
          value={selectedVehicle ? selectedVehicle.label : null}
        />
      </div>

      {/* Data e Hora de Entrada */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
          gap: '10px',
          marginTop: '10px',
        }}
      >
        <LabelInput
          type="date"
          value={
            values?.entry_date
              ? moment(values.entry_date).format('YYYY-MM-DD')
              : ''
          }
          disabled={true}
          placeholder={'Data entrada'}
          label={'Data entrada'}
        />
        <LabelInput
          value={values?.entry_hour || ''}
          disabled={true}
          placeholder={'Hora entrada'}
          label={'Hora entrada'}
        />
      </div>

      {/* Kilometragem */}
      <div style={{ marginTop: '10px' }}>
        <LabelInput
          value={values?.mileage || ''}
          disabled={true}
          placeholder={'Kilometragem'}
          type="number"
          label={'Kilometragem'}
        />
      </div>

      {/* Data e Hora de Entrega, Data e Hora de Fechamento */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr 1fr',
          gap: '10px',
          marginTop: '10px',
        }}
      >
        <LabelInput
          type="date"
          value={
            values?.delivery_date
              ? moment(values.delivery_date).format('YYYY-MM-DD')
              : ''
          }
          disabled={true}
          placeholder={'Previsão entrega'}
          label={'Previsão entrega'}
        />
        <LabelInput
          value={values?.delivery_hour || ''}
          disabled={true}
          placeholder={'Hora entrega'}
          label={'Hora entrega'}
        />
        <LabelInput
          type="date"
          value={
            values?.close_date
              ? moment(values.close_date).format('YYYY-MM-DD')
              : ''
          }
          disabled={true}
          placeholder={'Data fechamento'}
          label={'Data fechamento'}
        />
        <LabelInput
          value={values?.close_hour || ''}
          disabled={true}
          placeholder={'Hora fechamento'}
          label={'Hora fechamento'}
        />
      </div>

      {/* Condição de Pagamento */}
      {values.payment && (
        <div style={{ marginTop: '10px' }}>
          <LabelInput
            disabled={true}
            placeholder="Condição de pagamento"
            value={values?.payment?.label || values?.payment}
            label={'Condição de pagamento'}
          />
        </div>
      )}

      {/* Corresponsável Financeiro */}
      {selectedFinancialCoresponsible && (
        <div style={{ marginTop: '10px' }}>
          <LabelInput
            disabled={true}
            placeholder="Corresponsável financeiro"
            value={selectedFinancialCoresponsible.label}
            label={'Corresponsável financeiro'}
          />
        </div>
      )}

      {/* Status */}
      {values?.status && (
        <div style={{ marginTop: '10px' }}>
          <div style={{ marginBottom: '5px' }}>
            <label
              style={{
                color: 'white',
                fontFamily: 'poppins',
                fontSize: '14px',
                fontWeight: '500',
              }}
            >
              Status
            </label>
          </div>
          <div
            style={{
              backgroundColor: statusInfo.color,
              color: 'white',
              padding: '10px 15px',
              borderRadius: '4px',
              fontWeight: '500',
              textAlign: 'center',
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            {statusInfo.label}
          </div>
        </div>
      )}

      {/* Consultor */}
      <div style={{ marginTop: '10px' }}>
        <LabelInput
          disabled={true}
          placeholder="Consultor"
          value={consultant ? consultant.label : ''}
          label={'Consultor'}
        />
      </div>

      {/* Tipo de OS */}
      {values?.type_os && (
        <div style={{ marginTop: '10px' }}>
          <LabelInput
            disabled={true}
            placeholder="Tipo de OS"
            value={
              typeof values.type_os === 'object'
                ? values.type_os.label
                : values.type_os
            }
            label={'Tipo de OS'}
          />
        </div>
      )}

      {/* Observações */}
      {/* <div style={{ paddingBottom: '10px', marginTop: '10px' }}>
        <LabelInput
          type={'textarea'}
          inputClassname={'text-observation-min'}
          label={'Observações'}
          placeholder={'Insira a observação para a ordem de serviço'}
          onChange={() => {}}
          disabled={true}
          value={values.observation}
          className="external-observation-input"
        />
      </div> */}

      {/* Seção de Fotos */}
      {values?.image_checklist &&
        JSON.parse(values.image_checklist).length > 0 && (
          <div style={{ paddingBottom: '20px' }}>
            <text
              style={{
                color: 'white',
                fontWeight: '500',
                fontFamily: 'Poppins, sans-serif',
                fontSize: '16px',
                marginBottom: '10px',
                display: 'block',
              }}
            >
              Fotos da Ordem de Serviço
            </text>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isMobile
                  ? 'repeat(2, 1fr)'
                  : 'repeat(3, 1fr)',
                gap: '15px',
                marginTop: '10px',
              }}
            >
              {JSON.parse(values.image_checklist).map((imageItem, index) => (
                <div
                  key={imageItem.id || index}
                  style={{
                    border: '1px solid #333',
                    padding: '8px',
                    backgroundColor: '#2a2a2a',
                    borderRadius: '4px',
                  }}
                >
                  {/* Imagem */}
                  {imageItem.image && (
                    <img
                      src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${imageItem.image}`}
                      alt={`Registro ${index + 1}`}
                      style={{
                        width: '100%',
                        height: '120px',
                        objectFit: 'cover',
                        border: '1px solid #444',
                        marginBottom: '8px',
                        borderRadius: '4px',
                      }}
                    />
                  )}

                  {/* Informações */}
                  <div style={{ fontSize: '12px', color: 'white' }}>
                    {imageItem.piece && (
                      <div style={{ marginBottom: '4px' }}>
                        <strong>Peça:</strong>{' '}
                        {typeof imageItem.piece === 'object' &&
                        imageItem.piece !== null
                          ? imageItem.piece.label ||
                            String(imageItem.piece.value || '')
                          : String(imageItem.piece || '')}
                      </div>
                    )}
                    {imageItem.description && (
                      <div style={{ marginBottom: '4px' }}>
                        <strong>Descrição:</strong>{' '}
                        {typeof imageItem.description === 'object' &&
                        imageItem.description !== null
                          ? imageItem.description.label ||
                            String(imageItem.description.value || '')
                          : String(imageItem.description || '')}
                      </div>
                    )}
                    {imageItem.observation &&
                      typeof imageItem.observation === 'string' && (
                        <div style={{ marginBottom: '4px' }}>
                          <strong>Observação:</strong> {imageItem.observation}
                        </div>
                      )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
    </div>
  );
};

export default TabDetails;
